module.exports = __webpack_public_path__ + "img/grid_map_hover.bcc59d88.svg";